var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSectionTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00078 3V1H15.0008V3H9.00078ZM10.0008 14.75L8.90078 12.55C8.81745 12.3667 8.69245 12.229 8.52578 12.137C8.35911 12.045 8.18411 11.9993 8.00078 12H3.05078C3.30078 9.75 4.27578 7.85433 5.97578 6.313C7.67578 4.77167 9.68411 4.00067 12.0008 4C13.0341 4 14.0258 4.16667 14.9758 4.5C15.9258 4.83333 16.8174 5.31667 17.6508 5.95L19.0508 4.55L20.4508 5.95L19.0508 7.35C19.5841 8.05 20.0091 8.78767 20.3258 9.563C20.6425 10.3383 20.8508 11.1507 20.9508 12H16.6258L14.9008 8.55C14.7174 8.16667 14.4174 7.975 14.0008 7.975C13.5841 7.975 13.2841 8.16667 13.1008 8.55L10.0008 14.75ZM12.0008 22C9.68411 22 7.67578 21.2293 5.97578 19.688C4.27578 18.1467 3.30078 16.2507 3.05078 14H7.37578L9.10078 17.45C9.28411 17.8333 9.58411 18.025 10.0008 18.025C10.4174 18.025 10.7174 17.8333 10.9008 17.45L14.0008 11.25L15.1008 13.45C15.1841 13.6333 15.3091 13.771 15.4758 13.863C15.6424 13.955 15.8174 14.0007 16.0008 14H20.9508C20.7008 16.25 19.7258 18.1457 18.0258 19.687C16.3258 21.2283 14.3174 21.9993 12.0008 22Z",
    fill: "#228BE6",
    fillOpacity: 0.77
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionTimer);
export default __webpack_public_path__ + "static/media/section_timer.c310b4b84580aa3baa30c6e155bf70ba.svg";
export { ForwardRef as ReactComponent };